export default "/assets/images/dusty-taupe.02c1c0ef1af88571.webp";